import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
const guarantees = ['Cena: 69 PLN', 'Natychmiastowe Pobieranie', 'Brak Subskrypcji', 'Dostęp na Zawsze', '7 Dni Gwarancji'];
const EASE = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <section className="w-full bg-cream px-5 pb-20 pt-5" data-id="element-109" data-mp="4m8l89fgoljc">
      <div className="mx-auto max-w-4xl text-center" data-id="element-110" data-mp="4jm6npu5l5rm">
        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE
      }} className="font-display text-[2.5rem] font-black leading-[1.02] tracking-tight text-ink sm:text-6xl md:text-[4.2rem]" data-id="element-111" data-mp="128fqlljlahwr">
          Zaplanuj Cały Rok Lekcji Biologii w zaledwie{' '}
          <span className="italic text-brand" data-id="element-112" data-mp="nekkuoeqd8ps">5 Minut</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.08,
        ease: EASE
      }} className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-ink/60 sm:text-lg" data-id="element-113" data-mp="3d2tln1u126au">
          Dołącz do ponad 1 500 nauczycieli, którzy przestali improwizować.
          Wejdź do klasy z gotowymi materiałami, aby wyjaśniać, eksperymentować
          i inspirować.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.16,
        ease: EASE
      }} className="mx-auto mt-2 max-w-2xl pb-5 pt-2.5 sm:mt-8" data-id="element-114" data-mp="3e84odf6up2vm">
          <img src="https://cdn.magicpatterns.com/uploads/1uSAtdDHFhh6um8dUTjtxH/8c20a98e-2481-4db9-b5ad-86e98dbcfb09.webp" alt="Pakiet BIOLOGIA GOTOWA: osiem tomów od 4. Klasy Podstawówki do liceum z dostępem cyfrowym na komputer, tablet i smartfon oraz 5 ekskluzywnych bonusów w zestawie" className="mx-auto w-[85%] max-w-md sm:w-[80%]" data-id="element-115" data-mp="2qjv9yybyvhei" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.24,
        ease: EASE
      }} className="-mt-2 sm:mt-8" data-id="element-116" data-mp="s1rrwn4sk4tr">
          <CtaButton href="#offer" data-id="element-117" data-mp="ibgmsx9dfpla" />
          <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-xs font-semibold text-ink/50 sm:text-sm" data-id="element-118" data-mp="ichxv1qe0c30">
            {guarantees.map((item, index) => <li key={item} className="flex items-center gap-3" data-id="element-119" data-mp="1azkwdtv2cmt9" data-mpi={index}>
                <span data-id="element-120" data-mp="161aznetoxe5j">{item}</span>
                {index < guarantees.length - 1 && <span aria-hidden="true" className="text-ink/25" data-id="element-121" data-mp="112g6pk20e97p">
                    ·
                  </span>}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}